import { ICustomersState } from '../../types/interfaces'
import { ActionType } from '../actions/actionTypes'
import { CustomerAction } from '../actions/customerActions'
import initialState from '../reducers/initialState'
export default function customerReducer(
  state = initialState.customers as ICustomersState,
  action: CustomerAction
): ICustomersState {
  switch (action.type) {
    case ActionType.LOAD_CUSTOMERS_IN_PROGRESS:
      return {
        ...state,
        loading: true,
      }
    case ActionType.LOAD_CUSTOMERS_SUCCESS: {
      const customers = action.customers.sort((a, b) => (a.name || '').localeCompare(b.name || ''))
      const filteredCustomers = customers.filter((c) => c.totalContracts && c.totalContracts > 0)
      return {
        ...state,
        customers,
        filteredCustomers,
        loading: false,
      }
    }
    default:
      return state
  }
}
